import { render } from "./CustomSideBarAppModal.vue?vue&type=template&id=db87d76c"
import script from "./CustomSideBarAppModal.vue?vue&type=script&lang=js"
export * from "./CustomSideBarAppModal.vue?vue&type=script&lang=js"

import "./CustomSideBarAppModal.vue?vue&type=style&index=0&id=db87d76c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__